import React from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import OrderFilterDialogWrapper from "./FilterDialog/OrderFilterDialogWrapper";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const OrderListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const [openFilterDialog, setOpenFilterDialog] =
    React.useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <SideNavLayout>
      <div className="flex flex-col h-full p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            moduleName="ORDER"
            pageTitle="Orders"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton
            isFilter
            onFilterClick={() => setOpenFilterDialog(true)}
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
            onRowClick={(row) => navigate(`${row?._id}/order-view`)}
          />
        </div>

        <div className="p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
        {openFilterDialog ? (
          <OrderFilterDialogWrapper
            onClose={() => {
              setOpenFilterDialog(false);
            }}
          />
        ) : null}
      </div>
    </SideNavLayout>
  );
};

export default OrderListing;
